import { HeaderCellProps } from '../types';

export const TenantIdHeaderCell = ({ _customRowProps }: HeaderCellProps) => {
  return <div>ID</div>;
};
